function ConnectedUsersCtrl($scope, $state, $timeout){

	// get account id filter from parameters
	$scope.accountId = parseInt($state.params.accountId);
    $scope.connectedUserSiteDataMap;
    $scope.totalConnectedUsersAmount;

	/**
     * method for creating a mapping between account and the 
     * number of connected users, in addition sum all the connected users
    **/
    $scope.parseConnectedUsers = function () {
        $scope.totalConnectedUsersAmount = 0;
    	// iterate throw all account
    	for(var key in $scope.connectedUserSiteDataMap){
    		var size = (Object.keys($scope.connectedUserSiteDataMap[key])).length;
    		// add to the total sum
    		$scope.totalConnectedUsersAmount = $scope.totalConnectedUsersAmount + size;
    	}
    };

	angular.element(document).ready( function (){
       	store.fetch({
       		method : 'GET',
       		url : '/allConnectedUsers',
       		success: function(data, status, headers, config) {
                $timeout(function() {
                    $scope.dbDataMap = data[0];
                    $scope.connectedUserSiteDataMap = data[1];
                    $scope.parseConnectedUsers();
                }, 0);
            }
    	});
    });

	/**
	  * if a filter is defined get the given account number of connected users\sites
	  * else return the total amount of users\sites 
	*/ 
    $scope.getOnlineUsersAmount = function(accountIdFilter){
        if($scope.connectedUserSiteDataMap){
            if(!isNaN(accountIdFilter) && $scope.connectedUserSiteDataMap[accountIdFilter]){
                return Object.keys($scope.connectedUserSiteDataMap[accountIdFilter]).length;
            }
            else{
                return $scope.totalConnectedUsersAmount;
            }
        }
    }
} 